import { RemoveUserFromListModal } from './RemoveUserFromListModal';
import { AddUserToListModal } from './AddUserToListModal';

export const Modals = () => (
  <>
    <AddUserToListModal />
    <RemoveUserFromListModal />
  </>
);
